import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import MainLayout from './layouts/MainLayout';

// Pages
import Dashboard from './pages/Dashboard';
import ManageUsers from './pages/ManageUsers';
import HandleBookings from './pages/HandleBookings';
import TrackPayments from './pages/TrackPayments';
import MonitorCourses from './pages/MonitorCourses';
import ManageVehicles from './pages/ManageVehicles';
import ReviewAnalytics from './pages/ReviewAnalytics';
import SendNotifications from './pages/SendNotifications';
import CheckDocuments from './pages/CheckDocuments';
import SchoolOwnersDocuments from './pages/SchoolOwnersDocuments';
import InstructorsDocuments from './pages/InstructorsDocuments';
import ManageSettings from './pages/ManageSettings';
import FixProblems from './pages/FixProblems';
import Login from './pages/Login';
import EmployeeLogin from './employee/pages/EmployeeLogin';
import HrDashboard from "./employee/pages/HrDashboard";
import HrManageEmployees from "./employee/pages/HrManageEmployees";
import HrAssignTasks from "./employee/pages/HrAssignTasks";
import EmployeeTasks from "./employee/pages/EmployeeTasks";
import EmployeeRoutes from "./employee/EmployeeRoutes.js";
import HrPayouts from "./employee/pages/HrPayouts";
import HrLeaves from "./employee/pages/HrLeaves";
import CalendarPage from "./employee/pages/CalendarPage";
import IotTelemetry from './pages/IotTelemetry';
import EIS from './pages/EIS';
import Eye from './pages/Eye';

// Auth + Theme
import ProtectedEmployeeRoute from './employee/routes/ProtectedEmployeeRoute';
import ProtectedRoute from './routes/ProtectedRoute';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './theme/ThemeProvider';
import { EmployeeAuthProvider } from './employee/auth/EmployeeAuthContext';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <EmployeeAuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/login" element={<Login />} />
              <Route path="/iot_new_data" element={<IotTelemetry />} />
              <Route path="/eis" element={<EIS />} />
              <Route path="/eye" element={<Eye />} />


              {/* Protected area */}
              <Route element={<ProtectedRoute />}>
                <Route element={<MainLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="/users" element={<ManageUsers />} />
                  <Route path="/bookings" element={<HandleBookings />} />
                  <Route path="/payments" element={<TrackPayments />} />
                  <Route path="/courses" element={<MonitorCourses />} />
                  <Route path="/vehicles" element={<ManageVehicles />} />
                  <Route path="/review-analytics" element={<ReviewAnalytics />} />
                  <Route path="/notifications" element={<SendNotifications />} />
                  <Route path="/school-owners" element={<SchoolOwnersDocuments />} />
                  <Route path="/instructors" element={<InstructorsDocuments />} />
                  <Route path="/settings" element={<ManageSettings />} />
                  <Route path="/troubleshoot" element={<FixProblems />} />

                </Route>
              </Route>

              <Route
                path="/employee/*"
                element={
                  <EmployeeRoutes />
                }
              />



              {/* Fallback */}
              <Route path="*" element={<Navigate to="/login" replace />} />


            </Routes>
          </BrowserRouter>
        </EmployeeAuthProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
